import { render, staticRenderFns } from "./LensTagModal.vue?vue&type=template&id=7b38bc9d"
import script from "./LensTagModal.vue?vue&type=script&lang=js"
export * from "./LensTagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports